import React from "react";
import { Grid, Box } from "@mui/material";
import CloseRecruitmentReason from "../molecules/CloseRecruitmentReason";
import CloseRecruitmentButton from "../molecules/CloseRecruitmentButton";

export default function CloseRecruitment() {
  return (
    <Grid container sx={{ pt: "20px" }}>
      <Grid item xs={12} sm={9}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
            pb: { xs: "20px", sm: 0 },
          }}
        >
          <CloseRecruitmentReason />
        </Box>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
          }}
        >
          <CloseRecruitmentButton />
        </Box>
      </Grid>
    </Grid>
  );
}